import React from "react";
import { Link } from "react-router-dom";
import { Alert, AlertDescription, AlertTitle, Button } from "@capacit-com/lara-law-shared-ui";
import { Archive } from "lucide-react";
import AppRoutes from "@/constants/routes/AppRoutes";
import { DataSource } from "@/config/datasources";
import { resolveRetsinformationAccessionFromDocumentId } from "@/lib/deprecatedDatasources";

interface DeprecatedConsolidationDatasourcePageProps {
  documentId: string;
  datasource: string;
}

const DeprecatedConsolidationDatasourcePage: React.FC<
  DeprecatedConsolidationDatasourcePageProps
> = ({ documentId, datasource }) => {
  const retsinformationAccession =
    resolveRetsinformationAccessionFromDocumentId(documentId);

  return (
    <div className="mx-auto flex w-full max-w-2xl flex-col gap-6 py-8">
      <Alert variant="default" className="border-muted-foreground/25 bg-muted/30">
        <Archive className="text-muted-foreground" />
        <AlertTitle className="text-foreground">Denne kilde er udfaset</AlertTitle>
        <AlertDescription className="text-muted-foreground space-y-3">
          <p>
            Den tidligere {datasource}-kilde med færdiggenereret konsolideret
            lovtekst er erstattet af den nye konsolidering på
            Retsinformation-dokumenter.
          </p>
          <p>
            Du kan åbne den tilhørende lov på Retsinformation og bruge
            konsolideringsvisningen der, når den er tilgængelig.
          </p>
        </AlertDescription>
      </Alert>

      <div className="flex flex-wrap gap-3">
        <Button asChild>
          <Link
            to={AppRoutes.legislationHTML(
              retsinformationAccession,
              DataSource.Retsinformation
            )}
          >
            Åbn på Retsinformation
          </Link>
        </Button>
        <Button variant="outline" asChild>
          <Link to={AppRoutes.legislations}>Gå til kilder</Link>
        </Button>
      </div>
    </div>
  );
};

export default DeprecatedConsolidationDatasourcePage;
